<template>
  <div class="home">
    <div
      class="background"
      :style="{
        backgroundImage: 'url(' + require('@/assets/img/mayologobg2.png') + ')'
      }"
    ></div>
    <div class="logo">
      <img src="@/assets/img/mayologo.png" />
    </div>
    <div class="menu">
      <div class="left-bg">
        <div class="left">
          <h1>Gallery</h1>
          <div class="line"></div>
        </div>
      </div>

      <div class="right">
        <div id="app">
          <img
            class="image"
            v-for="(image, i) in images"
            :src="image"
            @click="index = i"
          />
          <vue-gallery-slideshow
            :images="images"
            :index="index"
            @close="index = null"
          ></vue-gallery-slideshow>
        </div>
        <!-- <div class="photo">
          <img src="@/assets/img/3939784_0011.jpg" />
        </div>
        <div class="photo">
          <img src="@/assets/img/3939784_0030.jpg" />
        </div>
        <div class="photo">
          <img src="@/assets/img/3939784_0080.jpg" />
        </div>
        <div class="photo">
          <img src="@/assets/img/3939784_0083.jpg" />
        </div>
        <div class="photo">
          <img src="@/assets/img/3939784_0100.jpg" />
        </div>
        <div class="photo">
          <img src="@/assets/img/3939784_0112.jpg" />
        </div>
        <div class="photo">
          <img src="@/assets/img/3939784_0130.jpg" />
        </div>
        <div class="photo">
          <img src="@/assets/img/3939784_0160.jpg" />
        </div> -->
        <!-- <div
          v-masonry
          transition-duration=".3s"
          item-selector=".item"
          class="masonry-container"
        >
          <div
            v-masonry-tile
            class="item"
            :key="index"
            v-for="(item, index) in contractors[distances.destination].media"
          >
            <img :src="item" />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import VueGallerySlideshow from "vue-gallery-slideshow";

export default {
  components: {
    VueGallerySlideshow
  },
  data() {
    return {
      images: [
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F1.jpg?alt=media&token=bbb22023-93a6-46c6-8cd0-81b1b6acc7b0",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F2.jpg?alt=media&token=55c5758d-e448-4d62-a7b1-f271b1b4601d",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F3.jpg?alt=media&token=ef8de91c-2488-48f7-bce7-12d9a7040c65",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F4.jpg?alt=media&token=87f1b7f6-7923-4a38-8c3f-27fe628f0b6f",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F5.jpg?alt=media&token=7c399e32-6302-49bf-8b6c-cb8505f21a74",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F6.jpg?alt=media&token=2982feff-13a2-458f-8e2f-fd321b531963",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F7.jpg?alt=media&token=55ab6331-f59c-4bba-8020-84a29f42693e",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F8.jpg?alt=media&token=7fb30d81-4da3-4705-a0a3-5190ca576229",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F9.jpg?alt=media&token=ffe980dd-e1d0-4584-900b-c8a30ff61763",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F10.jpg?alt=media&token=58fc89a4-0dd5-4541-b7b9-edfa651970db",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F11.jpg?alt=media&token=a7c045b6-814f-427d-b95c-64f812745314",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F12.jpg?alt=media&token=5638708a-a980-4bab-a1d0-21f100797171",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F13.jpg?alt=media&token=09bdfc97-7ebc-4691-bc41-976e212e0069",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F14.jpg?alt=media&token=1f0fb4e0-1a47-4b89-9611-0ddcb694da14",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F15.jpg?alt=media&token=cd713d52-2d58-45b4-a322-2fc3bdebf126",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F16.jpg?alt=media&token=c5b25dde-8431-4eb8-ac58-5252b968474f",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F17.jpg?alt=media&token=2e333e4a-a9b2-4b4e-9bcc-3a921f344571",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F18.jpg?alt=media&token=d8852792-cf27-468a-93eb-c24fb17a886e",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F19.jpg?alt=media&token=c417dcfe-dc27-4772-a08b-4947b8181c39",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F20.jpg?alt=media&token=a1e76f7a-cce1-4c37-82d1-5b2e36f46469",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F21.jpg?alt=media&token=6ec11ebc-3782-468f-bc77-c1977d0b47bc",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F22.jpg?alt=media&token=35e0ce84-731a-4c82-8297-23201c0f1809",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F23.jpg?alt=media&token=fdb3c767-6e44-43dd-91b3-cbdc52f93a2b",
        "https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2F24.jpg?alt=media&token=9a8ff529-7bb8-4784-b6c1-1b799afb822b"
      ],
      index: null
    };
  }
};
</script>
<style scoped>
.image {
  width: 150px !important;
  height: 150px !important;
  background-size: cover;
  cursor: pointer;
  margin: 5px;
  border-radius: 3px;
  border: 1px solid lightgray;
  object-fit: cover !important;
}
h1 {
  font-family: Palatino;
  color: #ffffff;
  font-size: 90px;
  position: relative;
  padding-top: 0px;
  width: 500px;
  text-align: center;
  font-weight: lighter;
  letter-spacing: 7px;
  text-align: left;
  margin: 0;
}

.left {
  /* padding-left: 157px;
    flex: none;
    padding-top: 301px;
    width: 500px; */

  /* css for demo */
  padding-right: 120px;
  padding-top: 315px;
  position: fixed;
  left: 200px;
}

.right {
  padding-top: 145px;
  padding-left: 600px;
  position: relative !important;
  display: flex !important;
  flex-wrap: nowrap !important;
  width: 54%;
  height: 100vh !important;
  justify-content: flex-start !important;
  overflow: hidden !important;
  overflow-x: auto !important;
  z-index: 10;
}

.btn {
  background-color: rgba(255, 255, 255, 0.1);
  z-index: 11;
  /* width: 100px;
  height: 50px;  */
}

.logo img {
  position: fixed;
  z-index: 11;
}

.menu {
  padding: 0;
  overflow: hidden !important;
}
.vgs__gallery {
  margin-bottom: 100px !important;
}
.vgs__container {
  margin-top: 100px !important;
}
</style>
